export const validateSavedViewDrawerForm = (t, { viewName }) => {
  const next = {};
  if (!viewName.trim()) next.viewName = t('reporting.viewNameRequired');
  return next;
};
